import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  checkbox: {
    color: "#1D5AB9", // Change the color to your desired color
    "&.Mui-checked": {
      color: "#1D5AB9", // Change the color when the checkbox is checked
    },
  },
}));

const CustomCheckbox = ({ ...rest }) => {
  const classes = useStyles();

  return (
    <Checkbox
      {...rest}
      classes={{
        root: classes.checkbox,
        checked: classes.checked,
      }}
      labelStyle={{ color: "#1D5AB9" }}
      iconStyle={{ fill: "#1D5AB9" }}
    />
  );
};

export default CustomCheckbox;
